import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PortalBookingNode } from '@app/services/api/api.types';

@Component({
  selector: 'booking-trip-card',
  templateUrl: './booking-trip-card.component.html',
  styleUrls: ['./booking-trip-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingTripCardComponent {
  @Input() isClickable: boolean = true;
  @Input()
  set data(value: PortalBookingNode) {
    this._data = value;
    this.confirmationNumbers =
      value.airlineConfirmations
        ?.map((airlineConfirmation) => airlineConfirmation.code)
        .join(', ') || '';
  }

  get data(): PortalBookingNode {
    return this._data;
  }

  private _data: PortalBookingNode;

  protected confirmationNumbers: string = '';
}
